<template>
    <!-- 换行设置组件
        @author: liuguisheng
        @date: 2019-11-21
    -->
    <div class="setting-item">
    <el-form-item label="是否换行"> 
      <el-radio-group v-model="wrap" size="small">
        <el-radio-button v-for="(item,index) in wrapConfigList"
                          :key="index" 
                          :label="item.label">{{item.value}}</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>
<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
// 导入换行配置文件
import { wrapConfigList } from '@/assets/js/config_dictionary.js';
export default {
  mixins: [ mixValueWatch ],
  data () {
    return {
      // 换行配置文件
      wrapConfigList
    }
  },
  computed: {
    /** @name 换行
     *  @description 将 wrap 字段映射到当前 wrap 计算属性
     *  @return { Boolean }
     *  @author liuguisheng
     *  @version 2019-11-21
     */
    ...mapComputed({
      wrap: { 
        parent: i => i.renderOption,
        attr: "wrap" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/render_setting/RenderWrap.vue